import {AppState} from '../../configStore';

export const selectIsNdeAnalyticsIdle = (state: AppState) => state.ndeAnalytics;
